import React, { useRef, useState } from 'react';
import './imageUploadMulti.scss';
import Button from './Button';
import * as imageConversion from 'image-conversion';

const ImageUploadMulti = props => {
  
  const [noOfImages, setNoOfImages] = useState();
  const [wait, setWait] = useState(false);
  const filePickerRef = useRef();
  
  const pickedHandler = async event => {

    setWait(true)

    let con1;
    let con2;
    let con3;
    let con4;
    let con5;
    
    if (event.target.files && event.target.files.length !== 0 ) {
      
      if (event.target.files.length > 5) {
        setNoOfImages(5)
      } else {
        setNoOfImages(event.target.files.length)
      }

      let pickedFile1 = event.target.files[0] || null;
      let pickedFile2 = event.target.files[1] || null;
      let pickedFile3 = event.target.files[2] || null;
      let pickedFile4 = event.target.files[3] || null;
      let pickedFile5 = event.target.files[4] || null;

      if (pickedFile1 !== null) {
        con1 = await imageConversion.compressAccurately(pickedFile1, 512);
      }
      if (pickedFile2 !== null) {
        con2 = await imageConversion.compressAccurately(pickedFile2, 512);
      }
      if (pickedFile3 !== null) {
        con3 = await imageConversion.compressAccurately(pickedFile3, 512);
      }
      if (pickedFile4 !== null) {
        con4 = await imageConversion.compressAccurately(pickedFile4, 512);
      }
      if (pickedFile5 !== null) {
        con5 = await imageConversion.compressAccurately(pickedFile5, 512);
      }

      setWait(false)
    }
    
    if (props.newExp) {
      props.handleChangeImages(con1, con2,con3, con4, con5);
    }

    if (props.editExp) {
      props.handleChangeImages(con1, con2,con3, con4, con5);
    }

    
  }
  

  const remove = () => {
    props.removeImage();
  };

  const pickImageHandler = () => {
    filePickerRef.current.click()
  }

  return (
    <div className='image-upload-multi' >
      <input type='file'
      multiple
      id={props.id}
      ref={filePickerRef}
      style={{display: 'none'}} 
      accept='.jpg,.png,.jpeg'
      onChange={pickedHandler}
      />
      
      {
      wait ? 
      (<div><h4>Please Wait</h4></div>)
      :
      (<div className='image-upload-control' >
        {!props.expPhoto1 && <Button type='button' onClick={pickImageHandler} ><i className="upload icon"></i></Button>}
        <Button style={{marginLeft: '10px'}} type='button' onClick={remove} ><i className="x icon"></i></Button>
      </div>)
      }

      {!wait && <div className='image-upload-info' > 
        {props.expPhoto1 && <span>No of images: {noOfImages}</span>}
        {!props.expPhoto1 && <span>max 5 images</span>} 
      </div>}
      
    </div>
  )
}

export default ImageUploadMulti;

